import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { Button, Form } from 'react-bootstrap';
import Slider from '../../Services/Slider';
import Alert from '../../Services/Alert';
import { prepareBannerImage, aspectWarning, BANNER_HINT } from '../../Services/BannerImage';
import BannerPreview from './BannerPreview';

export const SliderAdd = (props) => {
  const history = useHistory();
  const { register, handleSubmit, formState: { errors }, setValue } = useForm({ defaultValues: { status: "1", sort_order: 1 } });
  const [preview, setPreview] = useState('');
  const [warning, setWarning] = useState('');
  const [saving, setSaving] = useState(false);

  /* Default the order to "after the last banner". */
  useEffect(() => {
    Slider.list({ page: 0, size: 100, search: "", type: "mobile" }).then((res) => res.data).then(res => {
      if (res.status) {
        const last = (res.data.docs || []).reduce((max, b) => Math.max(max, b.sort_order || 0), 0);
        setValue('sort_order', last + 1);
      }
    }).catch(() => {});
  }, []);

  const imageField = register("image", { required: true });
  const onPick = (e) => {
    const file = e.target.files && e.target.files[0];
    setWarning('');
    if (!file) { setPreview(''); return; }
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => setWarning(aspectWarning(img.naturalWidth, img.naturalHeight));
    img.src = url;
    setPreview(url);
  };

  const onSubmit = async (data) => {
    setSaving(true);
    try {
      const { image, extension } = await prepareBannerImage(data.image[0]);
      const payload = {
        title: data.title,
        status: data.status,
        sort_order: parseInt(data.sort_order, 10) || 0,
        image,
        extension,
        type: "mobile",
      };
      const res = (await Slider.save(payload)).data;
      if (res.status) {
        Alert.success('Banner added.');
        history.push('/sliders');
      } else {
        Alert.error(res.message);
      }
    } catch (error) {
      Alert.error(error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <section className="main-content slideradd_main_sec">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title mb-4">Add Banner</h4>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                      <div className="row">
                        <div className="col-lg-6">
                          <Form.Group className="mb-3" controlId="formTitle">
                            <Form.Label>Title</Form.Label>
                            <Form.Control type="text" placeholder="For your reference (not shown in the app)" className="form-control" {...register("title", { required: true, maxLength: 80 })} />
                            <div className="error">
                              {errors.title?.type === 'required' && "Title is required"}
                            </div>
                          </Form.Group>
                        </div>
                        <div className="col-lg-6">
                          <Form.Group className="mb-3" controlId="formImage">
                            <Form.Label>Banner image</Form.Label>
                            <Form.Control type="file" accept="image/jpeg,image/png,image/webp" className="form-control"
                              {...imageField} onChange={(e) => { imageField.onChange(e); onPick(e); }} />
                            <div className="text-muted small mt-1">{BANNER_HINT}</div>
                            <div className="error">
                              {errors.image?.type === 'required' && "Image is required"}
                            </div>
                          </Form.Group>
                          <BannerPreview src={preview} label="How it will look in the app" />
                          {warning && <div className="text-warning small mb-3">{warning}</div>}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-3">
                          <Form.Group className="mb-3" controlId="formOrder">
                            <Form.Label>Order</Form.Label>
                            <Form.Control type="number" min="0" step="1" className="form-control" {...register("sort_order", { required: true, min: 0 })} />
                            <div className="text-muted small mt-1">Lower numbers show first.</div>
                            <div className="error">
                              {errors.sort_order && "Enter 0 or a positive number"}
                            </div>
                          </Form.Group>
                        </div>
                        <div className="col-lg-6">
                          <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <div className="col-lg-12">
                              <Form.Check inline label="Active (shown in the app)" value="1" id="active-status" type="radio" {...register("status", { required: true })} />
                              <Form.Check inline label="Inactive (hidden)" value="0" id="inactive-status" type="radio" {...register("status", { required: true })} />
                              <div className="error">
                                {errors.status?.type === 'required' && "Status is required"}
                              </div>
                            </div>
                          </Form.Group>
                        </div>
                      </div>
                      <div className="btn-submit">
                        <Button className="btn btn-primary w-md" type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save Banner'}</Button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default withRouter(SliderAdd);
